module.exports = __webpack_public_path__ + "images/042b2ccd4dca5fbdd9c35ba0ff977eee.png";